import React from "react";
import { PromoBar } from "./components/PromoBar";
import { Hero } from "./components/Hero";
import { PainSection } from "./components/PainSection";
import { HowItWorks } from "./components/HowItWorks";
import { Volumes } from "./components/Volumes";
import { Bonuses } from "./components/Bonuses";
import { Testimonials } from "./components/Testimonials";
import { Pricing } from "./components/Pricing";
import { Faq } from "./components/Faq";
import { Footer } from "./components/Footer";
export function App() {
  return <div lang="fr" className="min-h-screen w-full bg-ink font-sans text-cream antialiased" data-id="element-0" data-mp="2mn59mdtqiff4">
      <PromoBar data-id="element-1" data-mp="31bibfrfi6shj" />
      <main data-id="element-2" data-mp="31c1hoavsjsfq">
        <Hero data-id="element-3" data-mp="31ctflscv2296" />
        <PainSection data-id="element-4" data-mp="2wk08wyxu0jug" />
        <HowItWorks data-id="element-5" data-mp="2wjgptewg3peu" />
        <Volumes data-id="element-6" data-mp="2wiyv4mpflj91" />
        <Bonuses data-id="element-7" data-mp="2wifc12o1ootf" />
        <Testimonials data-id="element-8" data-mp="2whxd1y9zzwht" />
        <Pricing data-id="element-9" data-mp="28u5zkrcq1dey" />
        <Faq data-id="element-10" data-mp="28tmdcyg1g2v4" />
      </main>
      <Footer data-id="element-11" data-mp="28sutulzptvl7" />
    </div>;
}